import { Box, Drawer, useMediaQuery, useTheme } from "@mui/material";
import { useState } from "react";
import { Outlet } from "react-router-dom";
import CommunicationHeader from "./CommunicationHeader";
import CommunicationSideNav from "./CommunicationSideNav";
import LmsMain from "./LmsMain";

const DRAWER_WIDTH = 260;

function CommunicationLayout() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  const handleDrawerToggle = () => setMobileOpen((prev) => !prev);

  return (
    <Box sx={{ display: "flex" }}>
      {isMobile ? (
        <Drawer
          variant="temporary"
          open={mobileOpen}
          onClose={handleDrawerToggle}
          ModalProps={{ keepMounted: true }}
          sx={{
            display: { xs: "block", md: "none" },
            "& .MuiDrawer-paper": {
              boxSizing: "border-box",
              width: DRAWER_WIDTH,
              backgroundColor: "primary.main",
              color: "primary.contrastText",
            },
          }}
        >
          <CommunicationSideNav handleDrawerToggle={handleDrawerToggle} />
        </Drawer>
      ) : (
        <Box
          sx={{
            width: DRAWER_WIDTH,
            backgroundColor: "primary.main",
            color: "primary.contrastText",
            height: "100vh",
            position: "fixed",
            overflowY: "auto",
          }}
        >
          <CommunicationSideNav handleDrawerToggle={handleDrawerToggle} />
        </Box>
      )}

      <Box
        sx={{
          width: { xs: "100%", md: `calc(100% - ${DRAWER_WIDTH}px)` },
          ml: { xs: 0, md: `${DRAWER_WIDTH}px` },
          display: "flex",
          flexDirection: "column",
          minHeight: "100vh",
        }}
      >
        <CommunicationHeader
          drawerWidth={DRAWER_WIDTH}
          handleDrawerToggle={handleDrawerToggle}
        />
        <LmsMain>
          <Outlet />
        </LmsMain>
      </Box>
    </Box>
  );
}

export default CommunicationLayout;
